// Template type → the lowercase messageType gs-intg's mapper switches on (send-template.mapper.ts).
// CAROUSEL never reaches here — loadTemplatesForChannel filters out cardless carousels, and a
// carousel with cards sends through the carousel panel's own explicit messageType instead.
//
// GIF: Enterprise v11 SendMediaMessage accepts msg_type GIF for template sends only
// (SendMediaMessage.java:324, :423-426) and matches the template by media type, so a GIF template
// must go out as 'gif'; gs-intg routes any non-text messageType to SENDMEDIAMESSAGE and
// uppercases it into msg_type (send-template.mapper.ts:70-93). Without this a GIF template fell
// back to 'text'.
//
// LOCATION: becomes SENDMESSAGE msg_type LOCATION (LocationTemplateTypeHandler) — sent by the
// Standard send panel (src/templateSend/standard), which also carries the required
// gs-intg `location` object (see buildDefinition.js).
const TEMPLATE_TYPE_TO_MESSAGE_TYPE = {
  TEXT: 'text',
  IMAGE: 'image',
  VIDEO: 'video',
  DOCUMENT: 'document',
  GIF: 'gif',
  LOCATION: 'location',
};

export function messageTypeForTemplate(template) {
  return TEMPLATE_TYPE_TO_MESSAGE_TYPE[template?.details?.type] || null;
}
